import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { DayOfTheWeekOptionsType } from './types';
import { makeSelectOptions } from './selectors';

interface ConnectProps {
    options: DayOfTheWeekOptionsType;
}

interface OwnProps {
    component: React.ReactType;
    componentProps?: Record<string, any>;
}

type Props = ConnectProps & OwnProps;

export class DayOfTheWeekOptionsComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { component, componentProps, options } = this.props;

        return React.createElement(component, {
            ...componentProps,
            options
        });
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectProps
>({
    options: makeSelectOptions()
});

export default connect(mapStateToProps)(DayOfTheWeekOptionsComponent);
